
import { newList, addService } from "@/api/news_list";

export default {
  scrollToTop: true,
  head() {
    return {
      title: "巨得资讯-商城源码",
      meta: [
        {
          name: "description",
          content:
            "智软头条栏目整合商城源码类最新消息，帮助开发者快速搭建个性化在线商城。所有商城源码均为开源源码，包含B2C商城、B2B2C商城、S2B2C商城、O2O商城、社区团购等多种商城源码",
        },
        {
          name: "keywords",
          content:
            "智软头条,商城源码,开源商城系统,在线商城,源码,小程序商城源码,B2C商城源码,B2B2C商城源码,JAVA商城源码,多商户商城源码,在线商城源码,社区团购源码,O2O商城源码,S2B2C商城源码,app商城源码",
        },
      ],
    };
  },
  name: "list",
  async asyncData({ query }) {
    const type = ["1", "2", "3"].includes(query.type) ? query.type : "1";
    const params = `type/${type}/size/10/current/1`;
    const res = await newList(params);
    return {
      newsArr: res.data.data.records,
      total: res.data.data.total,
      type,
    };
  },
  data() {
    return {
      servicetitle: "立即预约",
      msgstatus: false,
      success: false,
      addform: {
        //添加预约
        mobilePhone: "",
      },
      newsArr: [],
      hotArrs: [], //热门新闻
      tabarr: [
        {
          type: "1",
          name: "行业新闻",
        },
        {
          type: "2",
          name: "公司新闻",
        },
        {
          type: "3",
          name: "功能更新",
        },
      ],
      params: {
        type: 1,
        size: 10,
        current: 1,
      },
      total: "",
      success: false,
      msg: "预约成功",
    };
  },
  methods: {
    changeinput() {
      if (this.addform.mobilePhone.length > 10) {
        this.msgstatus = false;
      }
    },
    handleSizeChange(val) {
      this.params.size = val;
      this.newList();
    },
    handleCurrentChange(val) {
      this.params.current = val;
      this.newList();
    },
    newList() {
      const query =
        "type/" +
        this.type +
        "/size/" +
        this.params.size +
        "/current/" +
        this.params.current;
      newList(query)
        .then((res) => {
          this.newsArr = res.data.data.records;
          this.total = res.data.data.total;
        })
        .catch((err) => {});
    },
    hotnewsList(type = 1) {
      const query = "type/" + type;
      newList(query)
        .then((res) => {
          this.hotArrs = [...res.data.data];
        })
        .catch((err) => {});
    },
    hidemsg() {
      setTimeout(() => {
        this.success = false;
      }, 2200);
    },
    addService() {
      if (this.addform.mobilePhone == "") {
        this.msgstatus = true;
        return false;
      }
      addService(this.addform)
        .then((res) => {
          this.success = true;
          if (res.data.code === 200) {
            this.addform.mobilePhone = "";
            this.msg = "预约成功";
          } else {
            this.msg = "手机号格式不正确";
          }
          this.hidemsg();
        })
        .catch((err) => {
          this.msg = "error";
        });
    },
  },
  mounted() {
    this.hotnewsList(1);
  },
};
